import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M8 .031c-.4 0-.815.16-1.125.469L.5 6.875c-.62.62-.62 1.63 0 2.25L6.875 15.5c.62.62 1.63.62 2.25 0L15.5 9.125c.62-.62.62-1.63 0-2.25L9.125.5A1.604 1.604 0 008 .031zm.152 2.975a3.001 3.001 0 011.97.873 3.006 3.006 0 01.65 3.27A2.998 2.998 0 019 8.82V10H7V8a1 1 0 011-1c.407 0 .768-.24.924-.617a.994.994 0 00-.217-1.09.994.994 0 00-1.09-.217A.994.994 0 007 6H5c0-1.21.733-2.308 1.852-2.771a2.98 2.98 0 011.3-.223zM8 11a1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1z" style={{
      marker: "none"
    }} color="#bebebe" overflow="visible" fill="#2e3436" /></svg>;
}

export default SvgComponent;